import * as Redux from 'redux';

import * as Api from '../../../weborder/Api';
import * as Store from '../../../weborder/Store';
import { fdApi } from '../../api';
import { store } from '.';
import { Campaign } from './store.types';
import { setCampaignProgress } from './storeActions';

type QueryParams = {
  count: number;
  includePhysicalRestaurantIds?: string;
  Latitude: number;
  Longitude: number;
  skip: number;
};

const loadCollectionSummaries = () => async (
  dispatch: Redux.Dispatch<Redux.Action>,
  getState: () => Store.State,
) => {
  const {
    Config,
    Location: { geo },
  } = getState().flipdish;

  const collectionParams: QueryParams = {
    count: 1000,
    Latitude: geo.Latitude,
    Longitude: geo.Longitude,
    skip: 0,
  };

  if (Config.IncludePhysicalRestaurantIds) {
    collectionParams.includePhysicalRestaurantIds =
      Config.IncludePhysicalRestaurantIds;
  }

  await fdApi
    .use(
      fdApi.store.getCollectionSummaries({
        params: collectionParams,
      }),
    )
    .then((data: Api.CollectionRestaurantSummary[]) => {
      dispatch(
        store.actions.setCollectionSummaries({
          data,
          status: 'success',
        }),
      );
    })
    .catch((_error) => {
      dispatch(
        store.actions.setCollectionSummaries({
          status: 'none',
        }),
      );
    });
};

const loadDeliverySummaries = () => async (
  dispatch: Redux.Dispatch<Redux.Action>,
  getState: () => Store.State,
) => {
  const {
    Config,
    Location: { geo },
  } = getState().flipdish;

  const deliveryParams = {
    count: 1000,
    deviceId: Config.DeviceId,
    Latitude: geo.Latitude,
    Longitude: geo.Longitude,
    skip: 0,
  };

  await fdApi
    .use(fdApi.store.getDeliverySummaries({ params: deliveryParams }))
    .then((data: Api.DeliveryRestaurantSummary[]) => {
      dispatch(
        store.actions.setDeliverySummaries({
          data,
          status: 'success',
        }),
      );
    })
    .catch((_error) => {
      store.actions.setDeliverySummaries({
        status: 'none',
      });
    });
};

export const getCampaignProgress = (storeId: number) => async (
  dispatch: Redux.Dispatch<Redux.Action>,
): Promise<void> =>
  fdApi
    .use(fdApi.store.getCampaignProgress(storeId))
    .then((data: Campaign[]) => {
      dispatch(
        setCampaignProgress({
          data,
          status: 'success',
          storeId,
        }),
      );
    })
    .catch((_error) => {
      setCampaignProgress({
        status: 'none',
        storeId,
      });
    });

export const storeMiddleware = {
  loadCollectionSummaries,
  loadDeliverySummaries,
};
